// extracted by mini-css-extract-plugin
module.exports =  {"container":"_32bbee5fda--container--EQEMh","text-wrapper":"_32bbee5fda--text-wrapper--c3QGu","success-icon-wrapper":"_32bbee5fda--success-icon-wrapper--gVhLo"};